import Header from "@/components/Header"
import Sidebar from "@/components/Sidebar"
import { akademikNavigations } from "@/constants"
import { useUser } from "@/hooks/useUser"
import { Navigate, Outlet } from "react-router-dom"

export default function AkademikLayout() {
  const { user, isPending } = useUser()
  const userRoles = user?.jenis_user || []
  const akademik = userRoles.includes("akademik")

  if (!isPending && !akademik) return <Navigate to={"/"} />

  return (
    <main className="flex">
      <Sidebar navigationMenus={akademikNavigations} />
      <section className="flex-1 overflow-x-auto p-5 min-h-screen">
        <Header />
        <Outlet />
      </section>
    </main>
  )
}
